<template>
  <v-app>
    <v-container fluid grid-list-md>
      <v-layout row>
        <v-flex xs12 sm4 offset-sm4>
          <v-card>
            <v-card-title>
              <span class="headline">New Password</span>
            </v-card-title>
            <v-card-text>
              Set a new password:
              <v-form v-model="formValid" ref="form">
                <v-text-field
                  name="input"
                  label="New Password"
                  v-model="passwordReset1"
                  required
                  :rules="rulesPassword"
                  type="password"
                  counter :min="passwordLength">
                ></v-text-field>
                <v-text-field
                  name="input"
                  label="Verify New Password"
                  v-model="passwordReset2"
                  required
                  :rules="rulesPassword"
                  type="password"
                  counter :min="passwordLength">
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click.native="reset">Set Password</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>

    <error-snackbar v-model="errorText"></error-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import ApiRequests from '@/api/ApiRequests'
import ErrorSnackbar from '@/components/ErrorSnackbar'
import Rules from '@/shared/rules'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      errorText: '',
      formValid: true,
      passwordLength: Rules.PASSWORDLENGTH,
      passwordReset1: '',
      passwordReset2: '',
      rulesPassword: [
        v => !!v || 'Password is required',
        v => Rules.password(v),
        v => this.passwordsEqual
      ]
    }
  },

  computed: {
    passwordsEqual: function () {
      if ((this.passwordReset1 === this.passwordReset2) || this.passwordReset2.length === 0) {
        return true
      } else {
        return 'Passwords are not the same'
      }
    },

    username: function () {
      var token = this.$route.query.token
      var sub = token.substring(64, token.length - 8)
      return this.hex2a(sub)
    }
  },

  methods: {
    reset: function () {
      this.$refs.form.validate()
      if (this.formValid) {
        var user = {}
        user.password = this.passwordReset1
        user.token = this.$route.query.token

        ApiRequests.passwordReset(user).then(response => {
          this.$router.push({ name: 'login' })
        }).catch(e => {
          this.errorText = 'Your password reset token is invalid, please contact support.'
          console.log(e)
        })
      }
    },

    hex2a: function (hexx) {
      var hex = hexx.toString()
      var str = ''
      for (var i = 0; (i < hex.length && hex.substr(i, 2) !== '00'); i += 2) {
        str += String.fromCharCode(parseInt(hex.substr(i, 2), 16))
      }
      return str
    }
  }
}
</script>
